import React, {useState, useContext, useRef, useEffect} from 'react'
import { IonInput, IonButton, IonItem, IonList,IonGrid, IonRow, IonCol, IonModal, IonContent } from '@ionic/react';
import { Redirect, Route, useHistory } from 'react-router-dom';

//import { Plugins } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences'
import Cookie from 'universal-cookie';

import { NativeBiometric } from "capacitor-native-biometric";

import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';
import { Reset_Password_Modal } from './ResetPasswordModal';

import '../../css/layout.css';

//const { Storage } = Plugins;
let cookies = new Cookie();


async function removeStorageCredentials() {


    await Preferences.remove({ key: 'accountID' });
    await Preferences.remove({ key: 'employeeID' });
    await Preferences.remove({ key: 'employee_first_name' });
    await Preferences.remove({ key: 'employee_last_name' });
    await Preferences.remove({ key: 'employee_company' });
    await Preferences.remove({ key: 'employee_createdBy' });
    await Preferences.remove({ key: 'schemaName' });
    await Preferences.remove({ key: 'isAuthenticated' });
    await Preferences.remove({ key: 'accessRights' });
    await Preferences.remove({ key: 'loginUsername_authenticated' });
    await Preferences.remove({ key: 'loginPassword_authenticated' });
    await Preferences.remove({ key: 'isBiometricFingerprintAvilable' });
    await Preferences.remove({ key: 'biometricFingerprint' });
    await Preferences.remove({ key: 'device' });
    await Preferences.remove({ key: 'sessionID' });
    await Preferences.remove({ key: 'baseURL' });
    await Preferences.remove({ key: 'capability' });
    await Preferences.remove({ key: 'feature' });

    let remove_cookie = null;

    cookies.remove('session', remove_cookie);


}

async function setStorageCredentials_admin(event) {

    //alert('In setStorageCredentials_admin');
    //alert(event);

    Preferences.set({
        key: 'accountID',
        value: event[0],
    })
    Preferences.set({
        key: 'schemaName',
        value: event[1],
    })
    Preferences.set({
        key: 'isAuthenticated',
        value: event[2],
    })
    // Preferences.set({
    //     key: 'accessRights',
    //     value: [event[3], event[4], event[5], event[6],  event[7]],
    // })
    Preferences.set({
        key: 'loginUsername_authenticated',
        value: event[8],
    })
    Preferences.set({
        key: 'loginPassword_authenticated',
        value: event[9],
    })
    Preferences.set({
        key: 'isBiometricFingerprintAvilable',
        value:  JSON.stringify(event[10]),
    })
    Preferences.set({
        key: 'biometricFingerprint',
        value:  JSON.stringify(event[11]),
    })
    Preferences.set({
        key: 'device',
        value: event[12],
    })

}

function setStorageCredentials_employee(event) {

    // alert('In setStorageCredentials_employee');
    // alert(event);
    // alert(event[7]);
    // alert(event[8]);
    //alert(event[9]);
    //alert(event[10]);
    //alert(event[11]);
    //alert([event[7], event[8], event[9], event[10],  event[11]].toString());

    Preferences.set({
        key: 'accountID',
        value: event[0],
    })
    Preferences.set({
        key: 'employeeID',
        value: event[1],
    })
    Preferences.set({
        key: 'employee_first_name',
        value: event[2],
    })
    Preferences.set({
        key: 'employee_last_name',
        value: event[3],
    })
    Preferences.set({
        key: 'employee_company',
        value: event[4],
    })



    Preferences.set({
        key: 'schemaName',
        value: event[5],
    })
    Preferences.set({
        key: 'isAuthenticated',
        value: event[6] ,
    })
    // Preferences.set({
    //     key: 'accessRights',
    //     value: [event[7], event[8], event[9], event[10],  event[11]].toString(),
    // })
    Preferences.set({
        key: 'loginUsername_authenticated',
        value: event[7],
    })
    Preferences.set({
        key: 'loginPassword_authenticated',
        value: event[8],
    })
    Preferences.set({
        key: 'employee_createdBy',
        value: event[9],
    })
    Preferences.set({
        key: 'isBiometricFingerprintAvilable',
        value: event[10],
    })
    Preferences.set({
        key: 'biometricFingerprint',
        value: event[11],
    })
    Preferences.set({
        key: 'device',
        value: event[12],
    })
}

function setStorageCredentials_employee_biometrics(event) {

    //alert('In setStorageCredentials_employee');
    //alert(event);
    //alert(event[7]);
    //alert(event[8]);
    //alert(event[9]);
    //alert(event[10]);
    //alert(event[11]);
    //alert([event[7], event[8], event[9], event[10],  event[11]].toString());
    Preferences.set({
        key: 'isBiometricFingerprintAvilable',
        value: event[0],
    })
    Preferences.set({
        key: 'biometricFingerprint',
        value: event[1],
    })
    Preferences.set({
        key: 'device',
        value: event[2],
    })
}

function setStorageCredentials_company(event) {



    // Preferences.set({
    //     key: 'capability',
    //     value: [event[0], event[1], event[2], event[3],  event[4], event[5]].toString(),
    // })

    Preferences.set({
        key: 'capability',
        value: JSON.stringify({
            basic: event[0],
            hotel: event[1],
            employee: event[2],
            proService: event[3],
            retail: event[4],
            jobs: event[5],
        })
    })

    // Preferences.set({
    //     key: 'feature',
    //     value: [event[0], event[1], event[2]].toString(),

    // })

    Preferences.set({
        key: 'feature',
        value: JSON.stringify({
            employeeHR: event[6],
            jobs: event[7],
        })
    })
}

function setStorageCredentials_accessRights(event) {

    Preferences.set({
        key: 'accessRights',
        value: [event[0], event[1], event[2], event[3],  event[4]].toString(),
    })

}

function setCookie(event) {

    //alert(event);
    //alert(event.toString());
     cookies.set('session', event);
}

function setStorageCredentials_sessionID(event) {

    //alert('In setStorageCredentials_sessionID');
    //alert(event);

    Preferences.set({
        key: 'sessionID',
        value: event,
    })
}

function storeCredentials(event) {

    alert("Inside Store Credential function");
    alert(event[0])
    alert(event[1])

    try {
    NativeBiometric.setCredentials({
        username: event[0],
        password: event[1],
        server: 'ghanaverifiedtest.com', // Replace with your server/domain
      });
      alert('Credentials stored successfully.');
    } catch (error) {
    alert('Failed to store credentials:', error);
    }
  }


function retrieveCredentials() {

    alert("Inside rETRIEVE Credential function");

    try {
      const credentials = NativeBiometric.getCredentials({
        server: 'ghanaverifiedtest.com', // Match the server used in setCredentials
      });
  
      alert('Retrieved credentials:');
      alert(`Username: ${credentials.username}`);
      alert(`Password: ${credentials.password}`);


      return credentials;

    } catch (error) {
      console.error('Failed to retrieve credentials:', error);
    }
  }

export function ZasavaLoginCredentials (props) {

    let authenticatedMerchent_context = useContext(Auth_Zasava_Context);


    let [loginUsername, setLoginUsername ] = useState('');
    let [loginPassword, setLoginPassword ] = useState('');

    let [acctID, setAccountID ] = useState(authenticatedMerchent_context.acctID);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);

    let [isbiometric_fingerprint_available, setIsBiometric_fingerprintAvilable] = useState(authenticatedMerchent_context.isBiometric_fingerprintAvilable);
    let [biometric_fingerprint, setBiometric_fingerprint] = useState(authenticatedMerchent_context.biometric_fingerprint);
    let [device, setDevice ] = useState(authenticatedMerchent_context.device);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [storeCredentials_biometric, setStoreCredentials_biometric] = useState(false);

    let [landingPage, setLandingPage] = useState();

    let [viewClockInModalClockOut, setClockInClockOutModal] = useState(false);

    let [viewResetPasswordModal, setResetPasswordModal] = useState(false);
    let history = useHistory();


    const usernameChangeHandler = (event) => {
        event.preventDefault();
        setLoginUsername(event.target.value);
    }

    const passwordChangeHandler = (event) => {
        event.preventDefault();
        setLoginPassword(event.target.value);
    }


    function handleConfirmEmployeeLogin_mobile(e) {

        //alert("in Handle confirmEmployeeLogin - before preventdefault");
        //alert(e);
        //alert(e[1]);
        //alert(e[2]);
        let line7_authenticated;





        /*let formData = new FormData();


        formData.append('Tracker', '71000');
        formData.append('xUsername', loginUsername);
        formData.append('xPassword', loginPassword);*/
        if(authenticatedMerchent_context.device == 'mobile')
        {
            // alert("NEED TO VERIFY");
            // alert(e[1]);
            // alert(e[2]);


            NativeBiometric.verifyIdentity({
                reason: "Setup - Fingerprint",
                title: "Biometric Setup",
                subtitle: "Authenticate to continue",
                description: "Place your finger on the sensor",
            }).then(() => {


                //alert('INSIDE FINGERPRINT 1');


                    let fetch_body = "";


                    if(e[0] == "verify_mobile")
                    {

                        fetch_body = {
                            Tracker: '9000',
                            xUsername: e[1],
                            xPassword: e[2],
                        };
                    }
                    else if (e[0] == 'setup_mobile')
                    {

                        if(loginUsername.trim().length === 0 || loginPassword.trim().length === 0)
                        {
                            return;
                        }
                
                        // if(storeCredentials_biometric == true)
                        // {

                        //     alert("Inside Store Credential is true");
                        //     alert(loginUsername);
                        //     alert(loginPassword)

                        //     storeCredentials([loginUsername, loginPassword]);
                        // }

                        fetch_body = {
                            Tracker: '9000',
                            xUsername: loginUsername,
                            xPassword: loginPassword,
                        };
                    }

                    // alert('INSIDE FINGERPRINT 2');
                    // alert(JSON.stringify(fetch_body));
                    // alert(baseURL);

                    fetch(baseURL+'zsava_public_indexApp', {
                    method: 'POST',
                    //credentials: 'include',
                    //mode: 'no-cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        //'content-type': 'text/html',
                        //'Access-Control-Allow-Origin':'*',
                        //'Access-Control-Allow-Methods':'POST,PATCH,OPTIONS',
                        //'content-type': 'application/x-www-form-urlencoded',
                        //'cookie': 'cookie',
                    },
                    body: JSON.stringify(fetch_body)})
                    .then(res => res.json())
                    .then(res => {

                        const trimmedOutput = res.out.trim();

                        if(trimmedOutput == "NULL")
                        {
                            alert('INCORRECT PASSWORD OR USERNAME. PLEASE TRY AGAIN.');
                        }
                                let rows = res.out.toString().split('~~~');
                                let lines = rows[0].split('|');
                                let lines2 = rows[1].split('|');


                                        if (lines[0] === "2" || lines[0] === "3" || lines[0] === "4" || lines[0] === "5")
                                        {

                                            //setStorageCredentials_employee([lines[1], lines[2], lines[3], lines[4], lines[5], lines[6], lines[7], lines[8], lines[9], lines[10], lines[11], lines[12], loginUsername, loginPassword, lines[13]])
                                            if(e[0] == "verify_mobile") setStorageCredentials_employee([lines[1], lines[2], lines[3], lines[4], lines[5], lines[8], lines[7], e[1], e[2], lines[6]]);
                                            if(e[0] == "setup_mobile") setStorageCredentials_employee([lines[1], lines[2], lines[3], lines[4], lines[5], lines[8], lines[7], loginUsername, loginPassword, lines[6]]);

                                            setCookie(res.cookies);

                                            setStorageCredentials_sessionID(res.id.toString());

                                            setStorageCredentials_company([lines2[0], lines2[1], lines2[2], lines2[3], lines2[4], lines2[5], lines2[6], lines2[7]])

                                            setStorageCredentials_employee_biometrics(['yes', 'yes', 'mobile'])

                                            if(e[0] == "verify_mobile")
                                            {
                                                authenticatedMerchent_context.changeLoginUsername(e[1]);
                                                authenticatedMerchent_context.changeLoginPassword(e[2]);
                                            }

                                            if(e[0] == "setup_mobile")
                                            {
                                                authenticatedMerchent_context.changeLoginUsername(loginUsername);
                                                authenticatedMerchent_context.changeLoginPassword(loginPassword);
                                            }


                                            //setLoginUsername('');
                                            //setLoginPassword('');

                                            authenticatedMerchent_context.changeSessionID(res.id.toString());
                                            authenticatedMerchent_context.changeAccountID(lines[1]);
                                            authenticatedMerchent_context.changeEmployeeID(lines[2]);
                                            authenticatedMerchent_context.changeEmployeeFirstName(lines[3]);
                                            authenticatedMerchent_context.changeEmployeeLastName(lines[4]);
                                            authenticatedMerchent_context.changeEmployeeCompany(lines[5]);

                                            authenticatedMerchent_context.changeSchema(lines[8]);
                                            authenticatedMerchent_context.changeBiometric_fingerprint('yes');

                                            line7_authenticated = lines[7];

                                            //authenticatedMerchent_context.changeAuthenticated(lines[7]);
                                            //authenticatedMerchent_context.changeAccessRights([lines[8], lines[9], lines[10], lines[11], lines[12]]);

                                            authenticatedMerchent_context.changeEmployeeCreatedBy(lines[6]);

                                            //authenticatedMerchent_context.changeCapability([lines2[0], lines2[1], lines2[2], lines2[3], lines2[4], lines2[5]]);


                                            //authenticatedMerchent_context.changeFeature([lines2[6], lines2[7]]);

                                            authenticatedMerchent_context.changeCapability(JSON.stringify({
                                                basic: lines2[0],
                                                hotel: lines2[1],
                                                employee: lines2[2],
                                                proService: lines2[3],
                                                retail: lines2[4],
                                                jobs: lines2[5],
                                            }));


                                            authenticatedMerchent_context.changeFeature(JSON.stringify({
                                                employeeHR: lines2[6],
                                                jobs: lines2[7],
                                            }));


                                            const requestOptions = {
                                                method: 'POST',
                                                headers: {
                                                    'Accept': 'application/json',
                                                    'Content-Type': 'application/json',
                                                },
                                                body: JSON.stringify({
                                                        Tracker: '9000_accessRigts',
                                                        user: lines[1],
                                                        sessionID: res.id.toString(),
                                                    })
                                            }


                                            fetch(baseURL+'zsava_internal_indexApp', requestOptions)
                                            .then(res2 => res2.text())
                                            .then(res2 => {
                                                

                                                        let rows3 = res2.toString().split('~~~');
                                    
                                    
                                                        let lines3 = rows3[0].split('|');

                                    
                                                        setStorageCredentials_accessRights([lines3[0], lines3[1], lines3[2], lines3[3], lines3[4]])
                                    
                                    
                                                        authenticatedMerchent_context.changeAccessRights([lines3[0], lines3[1], lines3[2], lines3[3], lines3[4]]);

                                                
                                                        if(line7_authenticated=== 'T0')
                                                        {
                        
                                                            //setLandingPage('/admin_zsava_indexApp');
                                                            history.push('/admin_zsava_indexApp');
                        
                                                            props.closeModal(false);
                        
                                                        }
                        
                                                        authenticatedMerchent_context.changeAuthenticated(line7_authenticated);
                            
                                    
                                                    })

                                                    alert("Fingerprint Authentication Successful");

                                        }
                                        else
                                        {
                                            alert('Incorrect Login or Password.  Please Try again');
                                        }

                                    })
                                    .catch((error) => {
                                        alert("ERROR : "+error);
                                        //alert("Fingerprint Authentication Failed");
                                        removeStorageCredentials();

                                    });

                                    
                            })
            }

    }

    function handleConfirmEmployeeLogin(e) {

        //alert(e);
        //alert(e[1]);
        //alert(e[2]);
        //e.preventDefault();
        let line7_authenticated;



        if(loginUsername.trim().length === 0 || loginPassword.trim().length === 0)
        {
            return;
        }


        /*let formData = new FormData();


        formData.append('Tracker', '71000');
        formData.append('xUsername', loginUsername);
        formData.append('xPassword', loginPassword);*/


        let fetch_body = "";

            fetch_body = {
                Tracker: '9000',
                xUsername: loginUsername,
                xPassword: loginPassword,
            };


        fetch(baseURL+'zsava_public_indexApp', {
          method: 'POST',
          //credentials: 'include',
          //mode: 'no-cors',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            //'content-type': 'text/html',
            //'Access-Control-Allow-Origin':'*',
            //'Access-Control-Allow-Methods':'POST,PATCH,OPTIONS',
            //'content-type': 'application/x-www-form-urlencoded',
            //'cookie': 'cookie',
        },
        body: JSON.stringify(fetch_body)})
        .then(res => res.json())
        .then(res => {


                    const trimmedOutput = res.out.trim();

                    if(trimmedOutput == "NULL")
                    {
                        alert('INCORRECT PASSWORD OR USERNAME. PLEASE TRY AGAIN.');
                    }


                    let rows = res.out.toString().split('~~~');
                    let lines = rows[0].split('|');
                    let lines2 = rows[1].split('|');


                            if (lines[0] === "2" || lines[0] === "3" || lines[0] === "4" || lines[0] === "5")
                            {

                                alert(authenticatedMerchent_context.device);

                                if(authenticatedMerchent_context.device == 'desktop')
                                {
                                    
    
    
    
                                //setStorageCredentials_employee([lines[1], lines[2], lines[3], lines[4], lines[5], lines[6], lines[7], lines[8], lines[9], lines[10], lines[11], lines[12], loginUsername, loginPassword, lines[13]])
                                setStorageCredentials_employee([lines[1], lines[2], lines[3], lines[4], lines[5], lines[8], lines[7], loginUsername, loginPassword, lines[6]])
                                setCookie(res.cookies);
    
                                setStorageCredentials_sessionID(res.id.toString());
    
                                setStorageCredentials_company([lines2[0], lines2[1], lines2[2], lines2[3], lines2[4], lines2[5], lines2[6], lines2[7]])
    
                                authenticatedMerchent_context.changeLoginUsername(loginUsername);
    
                                authenticatedMerchent_context.changeLoginPassword(loginPassword);
    
                                setLoginUsername('');
                                setLoginPassword('');
    
                                authenticatedMerchent_context.changeSessionID(res.id.toString());
                                authenticatedMerchent_context.changeAccountID(lines[1]);
                                authenticatedMerchent_context.changeEmployeeID(lines[2]);
                                authenticatedMerchent_context.changeEmployeeFirstName(lines[3]);
                                authenticatedMerchent_context.changeEmployeeLastName(lines[4]);
                                authenticatedMerchent_context.changeEmployeeCompany(lines[5]);
    
                                authenticatedMerchent_context.changeSchema(lines[8]);
    
                                line7_authenticated = lines[7];
    
                                //authenticatedMerchent_context.changeAuthenticated(lines[7]);
                                //authenticatedMerchent_context.changeAccessRights([lines[8], lines[9], lines[10], lines[11], lines[12]]);
    
                                authenticatedMerchent_context.changeEmployeeCreatedBy(lines[6]);
    
                                //authenticatedMerchent_context.changeCapability([lines2[0], lines2[1], lines2[2], lines2[3], lines2[4], lines2[5]]);
    
    
                                //authenticatedMerchent_context.changeFeature([lines2[6], lines2[7]]);
    
                                authenticatedMerchent_context.changeCapability(JSON.stringify({
                                    basic: lines2[0],
                                    hotel: lines2[1],
                                    employee: lines2[2],
                                    proService: lines2[3],
                                    retail: lines2[4],
                                    jobs: lines2[5],
                                }));
    
    
                                authenticatedMerchent_context.changeFeature(JSON.stringify({
                                    employeeHR: lines2[6],
                                    jobs: lines2[7],
                                }));
    
    
                                const requestOptions = {
                                    method: 'POST',
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({
                                            Tracker: '9000_accessRigts',
                                            user: lines[1],
                                            sessionID: res.id.toString(),
                                        })
                                }
    
                        
                                fetch(baseURL+'zsava_internal_indexApp', requestOptions)
                                .then(res2 => res2.text())
                                .then(res2 => {
    

                                            let rows3 = res2.toString().split('~~~');
                        
                        
                                            let lines3 = rows3[0].split('|');

                        
                                            setStorageCredentials_accessRights([lines3[0], lines3[1], lines3[2], lines3[3], lines3[4]])
                        
                        
                                            authenticatedMerchent_context.changeAccessRights([lines3[0], lines3[1], lines3[2], lines3[3], lines3[4]]);
            

                                            if(line7_authenticated=== 'T0')
                                            {
            
                                                //setLandingPage('/admin_zsava_indexApp');
                                                history.push('/admin_zsava_indexApp');
            
                                                props.closeModal(false);
            
                                            }
            
                                            authenticatedMerchent_context.changeAuthenticated(line7_authenticated);
            
                        
                                        })
    
                                }
    
                            }



                           
                })

    }

    function closeModalHandler() {

        props.closeModal(false);
    }

    function handleLogin(e)
    {

        if(authenticatedMerchent_context.device == 'mobile')
        {
            handleConfirmEmployeeLogin_mobile(['setup_mobile']);
        }
        else
        {
            handleConfirmEmployeeLogin();
        }
    }

    useEffect(() => {

            //alert('in useEffect 1');

            const fetchData = async () => {


                const username = (await Preferences.get({ key: 'loginUsername_authenticated' })).value;
                const password = (await Preferences.get({ key: 'loginPassword_authenticated' })).value;
        

            // alert(cookies.get('session'))
            // alert(authenticatedMerchent_context.loginUsername)
            // alert(authenticatedMerchent_context.loginPassword)
            // alert(authenticatedMerchent_context.device)
            // alert(username)
            // alert(password)

            if(authenticatedMerchent_context.device == 'mobile')
            {

                alert("IN MERCHANT LOGIN USE EFFECT MOBILE");

                setLoginUsername(username);
                setLoginPassword(password);
                //let credentials = retrieveCredentials();

                //alert("CREDENTIALS");
                // alert(credentials.username);
    
                if(username != undefined)
                {
                    alert("INSIDE CREDETIAL IS NOT EQUAL TO UNDEFINED")

                    handleConfirmEmployeeLogin_mobile(['verify_mobile', username, password]);
                }
                else if(username == undefined)
                {
                    alert("INSIDE CREDETIAL IS EQUAL TO UNDEFINED")
                    
                    setStoreCredentials_biometric(true);
                }
            }
        }

        //alert('in useEffect 2');


        fetchData();

        
    }, [])

    //alert('in LoginCredential_merchant');
    //alert(landingPage)

    return (

             /*<React.Fragment>
                {authenticatedMerchent_context.authenticated == null && 
                    (<React.Fragment><IonInput id="merchantUsername" placeholder="Enter Username" value={loginUsername} onIonChange={usernameChangeHandler }></IonInput>
                    <IonInput id="merchantPassword" placeholder="Enter Password" value={loginPassword} onIonChange={passwordChangeHandler }></IonInput>
                    <IonButton slot="end" onClick={ handleConfirmMerchantLogin }>Admin Login</IonButton>
                    <IonButton slot="end" onClick={ handleConfirmEmployeeLogin }>Employee Login</IonButton></React.Fragment>)}

            </React.Fragment>*/
    

        <React.Fragment>

                <IonModal isOpen={ props.openModal }>

                        <IonGrid className='login_grid'>
                            <IonRow >
                                <IonCol size='6'>
                                    <IonInput id="merchantUsername" placeholder="Enter Username" value={loginUsername} onIonChange={usernameChangeHandler }></IonInput>
                                </IonCol>
                                <IonCol size='6'>
                                    <IonInput type='password' id="merchantPassword" placeholder="Enter Password" value={loginPassword} onIonChange={passwordChangeHandler }></IonInput>
                                </IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol size='6'>
                                    {/*<button onClick={handleConfirmEmployeeLogin}>Login</button>*/}
                                    <IonButton onClick={(e) => handleLogin(e)}>Login</IonButton>
                                </IonCol>

                                {/*<IonCol size='6'>
                                    <IonButton onClick={ handleConfirmEmployeeLogin }>SetUp Fingerprint</IonButton>
                                </IonCol>*/}
                            </IonRow>
                            <IonRow >
                                <IonCol size='6'>
                                    <IonButton onClick={() => setResetPasswordModal(true) }>Reset Password</IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>

                    {viewResetPasswordModal && <Reset_Password_Modal openModal={ viewResetPasswordModal } closeModal={() => setResetPasswordModal(false)}></Reset_Password_Modal>}

                    <IonButton onClick={() => props.closeModal(false)}>Close</IonButton>
                </IonModal>
                   
        </React.Fragment>  
    )
     
}